import { useEffect, useState } from "react";
import { Box, Typography, Grid, Paper, CardMedia } from "@mui/material";
import { useParams, useHistory } from "react-router-dom";

// Components
import ViewOverview from "./ViewOverview";
import ViewGuidelines from "./ViewGuidelinesFaq";
import OfferAnalytics from "./OfferAnalytics";
import ReusableHeadingComponents from "../../components/reusableComponents/reusableHeadingComponents";
import Application from "./Application";
import ReusableChip from "../../components/reusableComponents/chipSelector";
import ViewDeliverable from "./ViewDeliverable";
import CustomTabs from "../../components/reusableComponents/CustomTabs";
import ApiService from "../../_services/ApiService";
import { useMultiStepFormHandler } from "../../hooks/useMultistepFormHandler";
import dayjs from "dayjs";
import offerClicks from '../../img-offer/offerClicks.svg'
import People from '../../img-offer/peoples.svg'
import Sensor from '../../img-offer/sensor.svg'
import Shipping from '../../img-offer/shipping.svg'
import Approved from '../../img-offer/approved.svg'
import { CardSkeletonCounts } from "../../components/reusableComponents/SkeletonCard";
import { getCampaignStatus, getCampaignStatusColor } from "../../_helpers/reusablefunctions/campaignStatus";

const tabs = [
    "overview",
    "targeting",
    "guidelines",
    "application",
    "analytics",
    // "review"
];

const tabLabels = {
    overview: "Overview",
    targeting: "Deliverables & Targeting",
    guidelines: "Guidelines & FAQ",
    application: "Application",
    analytics: "Analytics",
    // review: "Reviews"
};

const MetricCard = ({ icon, value, label }) => (
    <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
        <Box display="flex" sx={{ flexDirection: 'column' }}>
            <Box display='flex' gap={2} alignItems={"center"}>
                <CardMedia
                    component='img'
                    height={32}
                    image={icon}
                    alt={icon}
                    sx={{ width: 32 }}
                />
                <Typography variant="h6" sx={{ color: '#2B3674', fontSize: '28px', fontWeight: 700 }}>{value}</Typography>
            </Box>
            <Box>
                <Typography variant="caption" sx={{ color: '#8C8C8C', fontSize: '14px', fontWeight: 400 }}>{label}</Typography>
            </Box>
        </Box>
    </Paper>
);

const OfferDetailComponent = () => {
    const history = useHistory();
    const { offerId, tabName } = useParams();
    const [activeTab, setActiveTab] = useState(tabName);
    const [statsData, setStatsData] = useState();
    const [loading, setLoading] = useState();

    useEffect(() => {
        setActiveTab(tabName);
    }, [tabName]);

    const handleTabChange = (newTab) => {
        history.push(`/view-offer/${offerId}/${newTab}`);
    };

    const {
        formData: offerDetail,
        fetchOfferDetails,
    } = useMultiStepFormHandler({
        userData: {},
        campaignTypeFromUrl: null,
        activeStep: 0,
        steps: [],
        history,
        successSnack: () => { },
        errorSnack: () => { },
        formSnackbar: {}
    });

    const getCampaignType = (campaignName) => {
        switch (campaignName) {
            case "Barter Campaign":
                return "bartercampaign";
            default:
                return "bartercampaign";
        }
    };


    useEffect(() => {
        if (offerId) fetchOfferDetails(offerId);
    }, [offerId]);

    useEffect(() => {
        if (!offerId ) return;
        const getSubmissionStats = async () => {
            setLoading(true);
            try {
                const params = {
                    campaign_id: offerId,
                    campaign_type: getCampaignType(offerDetail?.campaign_type?.campaign_name),
                };

                const response = await ApiService.get("get_submission_stats", params);
                console.debug("result", response?.data);
                setStatsData(response?.data);
            } catch (error) {
                console.error("Error fetching submission stats", error);
            } finally {
                setLoading(false);
            }
        };

        if (offerId && offerDetail) {
            getSubmissionStats();
        }
    }, [offerId, offerDetail ,offerDetail?.campaign_type?.campaign_name]);

    const renderTabContent = () => {
        switch (activeTab) {
            case "overview":
                return <ViewOverview offerDetail={offerDetail} />;
            case "targeting":
                return <ViewDeliverable offerDetail={offerDetail} />;
            case "guidelines":
                return <ViewGuidelines offerDetail={offerDetail} />;
            case "application":
                return <Application />;
            case "analytics":
                return <OfferAnalytics />;
            // case "review":
            //     return <InfluencerReviewPage />
            default:
                return null;
        }
    };

    const metrics = [
        { icon: offerClicks, value: statsData?.total_clicks || '0', label: 'Total Clicks' },
        { icon: People, value: statsData?.applied_count || '0', label: 'Total Applied' },
        { icon: Approved, value: statsData?.approved_count || '0', label: 'Total Approved' },
        { icon: Shipping, value: statsData?.product_delivered_count || '0', label: 'Total Product Delivered' },
        { icon: Sensor, value: statsData?.closed_count || '0', label: 'Total Application Closed' }
    ];

    const handleBack = () => {
        history.push("/new-offer")
    }

    const campaignStatus = getCampaignStatus(offerDetail);

    return (
        <Box p={4}>
            <Box sx={{ display: "flex", alignItems: { xs: 'flex-start', md: "center" }, justifyContent: 'space-between', flexDirection: { xs: 'column', md: 'row' } }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <ReusableHeadingComponents bacHistory={true} clickHandlerBack={handleBack} heading={<>
                        Barter Offer Details <ReusableChip
                            label={campaignStatus}
                            bgcolor={getCampaignStatusColor(campaignStatus).bgcolor}
                            color={getCampaignStatusColor(campaignStatus).color}
                            borderRadius="16px"
                        />
                    </>}
                        subHeading={`Created On : ${dayjs(offerDetail?.campaign_type?.created_at).format("DD/MM/YYYY")}  |    Offer ID: ${offerDetail.id}`}

                    />
                </Box>
                {/* <Box display='flex' gap="20px" sx={{ paddingBottom: { xs: '10px', md: '0' } }}>
                    <ReusableBtn label="Duplicate" icon={<ReusableMuiIcons name="copy" />} />
                    <ReusableBtn label="Close" icon={<ReusableMuiIcons name="close" />} />
                </Box> */}
            </Box>
            <Grid container spacing={2} mb={4}>
                {loading ? (
                    Array.from({ length: 5 }).map((_, i) => (
                        <Grid item xs={12} sm={6} md={4} lg={2} key={i}>
                            <CardSkeletonCounts />
                        </Grid>
                    ))
                ) : (metrics.map((metric, i) => (
                    <Grid item xs={12} sm={6} md={2.4} key={i}>
                        <MetricCard {...metric} />
                    </Grid>
                )))}
            </Grid>
            <CustomTabs
                tabs={tabs}
                activeTab={activeTab}
                onTabChange={handleTabChange}
                tabLabels={tabLabels}
            />
            {/* Content */}
            <Box>{renderTabContent()}</Box>
        </Box>
    );
};

export default OfferDetailComponent;
